import { Form, Input } from "antd";
import { useTranslation } from "react-i18next";

import { confirmPasswordRules, passwordRequiredRule } from "./utils/utils";

export const NewPasswordFields = () => {
  const { t } = useTranslation(["common"]);

  return (
    <>
      <Form.Item
        name="newPassword"
        label={t("passwordLogin.newPasswordLabel")}
        rules={[passwordRequiredRule(t)]}
      >
        <Input.Password size="large" autoComplete="new-password" />
      </Form.Item>

      <Form.Item
        name="confirmPassword"
        label={t("passwordLogin.confirmPasswordLabel")}
        dependencies={["newPassword"]}
        rules={confirmPasswordRules(t, "newPassword")}
      >
        <Input.Password size="large" autoComplete="new-password" />
      </Form.Item>
    </>
  );
};
